import { BulkAddProcessesRequestSchema, BulkAddProcessesResponseSchema } from './bulk-add-processes.schema';
export const bulkAddProcessesContract = {
    method: 'POST',
    path: '/api/v2/process/bulk',
    description: 'Bulk create processes (post-onboarding; no initialization gate)',
    requestSchema: BulkAddProcessesRequestSchema,
    responseSchema: BulkAddProcessesResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=bulk-add-processes.contract.js.map